<!--
 * @Author: ljc
 * @Description: pdf报告——第十四页
 * @Date: 2022-09-27 13:21:47
 * @LastEditors: weijinpeng
-->
<template>
   <div class="pdfPage">
        <Headers></Headers>
        <main class="main">
            <div class="pdfPageTitle">
                <div class="pdfPageTitle-txt">
                    <span class="pdfPageTitle-txt__first">总结</span>
                </div>
                <!-- <div class="pdfPageTitle-icon">
                    <img src="@/assets/img/page9.png">
                </div> -->
            </div>
            <div class="summary">
                <p class="summary-txt">{{PdftStore.fromData.questionnaireInfo?.conclusion}}</p>
                <!-- <p class="summary-txt">{{PdftStore.fromData.questionnaireInfo?.overviewSummary}}</p> -->
            </div>
            <div class="nav">
                <!-- <List :type=11  :id="'listPdfReport10'"/> -->
                <!-- 得分详情 -->
                <a-row class="list" align="middle">

                    <!-- 总分 -->
                    <a-col class="mg_r">
                        <a-progress type="circle" :width="170" strokeColor="#00baf4" :percent="PdftStore.fromData.questionnaireInfo?.score">
                            <template #format="percent">
                                <span style="color:#013C89;font-size: 72px;">{{ Math.round(percent) || 0 }}</span>
                            </template>
                        </a-progress>
                    </a-col>

                    <!-- 运营排放 -->
                    <a-col class="list_r">
                        <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionOperational?.updateScore">
                            <template #format="percent">
                                <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                            </template>
                        </a-progress>
                        <div class="list_b">
                            <div class="flex">
                                <div class="t">运营排放</div>
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionOperational?.weightScore || 0}}</div>
                            </div>
                            <div class="flex mg_top_list">
                                <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionOperational?.weight}}%</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                    </a-col>

                    <!-- 产业链排放 -->
                    <a-col class="list_r">
                        <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionIndustrialChain?.updateScore">
                            <template #format="percent">
                                <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                            </template>
                        </a-progress>
                        <div class="list_b">
                            <div class="flex">
                                <div class="t">产业链排放</div>
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionIndustrialChain?.weightScore || 0}}</div>
                            </div>
                            <div class="flex mg_top_list">
                                <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionIndustrialChain?.weight}}%</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                    </a-col>

                    <!-- 直接减排贡献 -->
                    <a-col class="list_r">
                        <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionDirectReduction?.updateScore">
                            <template #format="percent">
                                <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                            </template>
                        </a-progress>
                        <div class="list_b">
                            <div class="flex">
                                <div class="t">直接减排贡献</div>
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionDirectReduction?.weightScore || 0}}</div>
                            </div>
                            <div class="flex mg_top_list">
                                <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionDirectReduction?.weight}}%</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                    </a-col>

                    <!-- 间接减排贡献 -->
                    <a-col class="list_r">
                        <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionIndirectReduction?.updateScore">
                            <template #format="percent">
                                <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                            </template>
                        </a-progress>
                        <div class="list_b">
                            <div class="flex">
                                <div class="t">间接减排贡献</div>
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionIndirectReduction?.weightScore || 0}}</div>
                            </div>
                            <div class="flex mg_top_list">
                                <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionIndirectReduction?.weight}}%</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                    </a-col>

                    <!-- 零碳运营 -->
                    <a-col class="list_r">
                        <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionZeroOperation?.updateScore">
                            <template #format="percent">
                                <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                            </template>
                        </a-progress>
                        <div class="list_b">
                            <div class="flex">
                                <div class="t">零碳运营</div>
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionZeroOperation?.weightScore || 0}}</div>
                            </div>
                            <div class="flex mg_top_list">
                                <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionZeroOperation?.weight}}%</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                    </a-col>

                    <!-- 绿色供应链 -->
                    <a-col class="list_r">
                        <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionGreenSupply?.updateScore">
                            <template #format="percent">
                                <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                            </template>
                        </a-progress>
                        <div class="list_b">
                            <div class="flex">
                                <div class="t">绿色供应链</div>
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionGreenSupply?.weightScore || 0}}</div>
                            </div>
                            <div class="flex mg_top_list">
                                <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionGreenSupply?.weight}}%</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                    </a-col>

                    <!-- 承诺与披露 -->
                    <a-col class="list_r">
                        <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionPromise?.updateScore">
                            <template #format="percent">
                                <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                            </template>
                        </a-progress>
                        <div class="list_b">
                            <div class="flex">
                                <div class="t">承诺与披露</div>
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionPromise?.weightScore || 0}}</div>
                            </div>
                            <div class="flex mg_top_list">
                                <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionPromise?.weight}}%</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                    </a-col>

                    <!-- 零碳投资 -->
                    <a-col class="list_r">
                        <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionZeroInvestment?.updateScore">
                            <template #format="percent">
                                <span style="color:#00BAF4;font-size: 26px;">{{ Math.round(percent) || 0 }}</span>
                            </template>
                        </a-progress>
                        <div class="list_b">
                            <div class="flex">
                                <div class="t">零碳投资</div>
                                <div class="t_m">{{PdftStore.fromData.spaceEmissionZeroInvestment?.weightScore || 0}}</div>
                            </div>
                            <div class="flex mg_top_list">
                                <div class="t_a">权重 {{PdftStore.fromData.spaceEmissionZeroInvestment?.weight}}%</div>
                                <div class="s_j"></div>
                            </div>
                        </div>
                    </a-col>

                </a-row>
            </div>
            <div class="showcase">
                <div class="showcase-chart" v-if="PdftStore.fromData.spaceEmissionOther">
                    <Echarts :name="'page14echarts'"/>
                </div>
                <div class="showcase-grade">
                    <div class="gra_box">
                        <Logos :ids="'arctext6'"/>
                        <div class="logoboxtxt">
                            <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <ul class="baseInfo">
                <li>
                    <div class="baseInfo-title">数据录入：</div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.inputUser}}</div>
                </li>
                <li style="margin-left: 30px;">
                    <div class="baseInfo-title">报告撰写：</div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.writeUser}}</div>
                </li>
                <li style="margin-left: 30px;">
                    <div class="baseInfo-title">报告审核：</div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.checkUser}}</div>
                </li>
                <li>
                    <div class="baseInfo-title">录入时间：</div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.inputTime}}</div>
                </li>
                <li style="margin-left: 30px;">
                    <div class="baseInfo-title">撰写时间：</div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.writeTime}}</div>
                </li>
                <li style="margin-left: 30px;">
                    <div class="baseInfo-title">审核时间：</div>
                    <div class="baseInfo-txt">{{PdftStore.fromData.questionnaireInfo?.checkTime}}</div>
                </li>
            </ul>
            <Bottoms/>
            <div class="flxed">12</div>
        </main>
        <!-- 底部 -->
        
   </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue';
import List from '../components/list.vue';
import Echarts from '../components/echarts.vue';
import Logos from '../components/logos.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page14',
    components:{Headers, Bottoms, List, Echarts, Logos},
    setup() {
        const data = reactive({})
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.flxed{
    position: absolute;
    right: 20px;
    bottom: 20px;
    font-size: 24px;
    font-weight: 400;
    color: #333333;
    line-height: 33px;
}

.pdfPage{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .main {
        width: 100%;
        padding: 96px 130px 0 130px;
        
    }
    .summary{
        margin-top: 30px;
        &-txt {
            font-size: 16px;
            text-align: justify;
            font-weight: 400;
            color: #333333;
            line-height: 32px;
        }
    }
    .nav {
        // margin-top: 170px;
        // height: 220px;
    }
    .showcase{
        width: 100%;
        height: 480px;
        margin-top: 36px;
        display: flex;
        justify-content: space-between;
        padding: 56px 0;
        // border-bottom: 2px solid #013C89;
        &-chart {
            width: 660px;
            height: 100%;
            position: relative;
            &::before {
                content: '';
                width: 3px;
                height: calc(100% - 40px);
                position: absolute;
                right: -26px;
                top: 50%;
                transform: translateY(-50%);
                border-right: 1px dashed #C5C5C6;
            }
        }
        &-grade {
            width: 540px;
            height: 100%;
            display: flex;
            justify-content: center;
            .gra_box{
                .img_box{
                    width: 250px;
                    height: 85px;
                    margin: 0;
                    margin-top: 66px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
            }
            
        }
    }
    .baseInfo{
        display: flex;
        flex-wrap: wrap;
        padding: 60px 0px;
        margin: 0 130px;
        border-top: 2px solid #013C89;
        position: absolute;
        bottom: 150px;
        left: 0;
        right: 0;
        li {
            width: calc((100% - 60px) / 3);
            display: flex;
            &:nth-child(-n + 3) {
                margin-bottom: 80px;
            }
        }
        &-title {
            font-size: 24px;
            font-weight: bold;
            color: #333333;
            line-height: 33px;
            width: 130px;
        }
        &-txt {
            position: relative;
            padding: 0 6px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 33px;
            width: calc(100% - 130px);
            &::before {
                content: '';
                width: calc(100% - 20px);
                position: absolute;
                left: 0;
                bottom: -8px;
                border: 1px solid #999;
            }
        }
    }
}
.logoboxtxt{
    max-width: 240px;
    max-height: 84px;
    min-width: 240px;
    min-height: 84px;
    width: 240px;
    height: 84px;
    text-align: center;
    margin: 30px auto 0 auto;
    img{
        width: auto;
        height: 56px;
    }
}
.list{
    margin-top: 30px;
    width: 100%;
    height: 220px;
    border-top: 1px solid #C5C5C6;
    border-bottom: 1px solid #C5C5C6;
}
.mg_r{
    margin-right: 65px;
}
.list_r{
    width: 109px;
    margin: 0 9px;
    height: 100%;
    padding: 40px 0;
    text-align: center;
    .list_b{
        padding-top: 12px;
        margin-top: 10px;
        border-top: 2px solid #322523;
        .mg_top_list{
            padding-top: 12px;
        }
        .flex{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .t{
                font-size: 12px;
                font-weight: 400;
                color: #333333;
                line-height: 17px;
            }
            .t_m{
                font-size: 14px;
                font-weight: 600;
                color: #013C89;
                line-height: 17px;
            }
            .t_a{
                font-size: 14px;
                font-weight: 400;
                color: #333333;
                line-height: 17px;
            }
            .s_j{
                margin-right: 3px;
                width:0;
                height:0;
                border-left:5.5px solid transparent;
                border-right:5.5px solid transparent;
                border-bottom:11px solid #013C89;
            }
            
        }
    }
}
</style>